<template>
  <div class="animated fadeIn" style="min-height:900px;display:flex;
  flex-flow:column;height:100%;">
    <!-- Cancellations -->
    <b-container fluid class="pt-0 pr-3 pb-0 pl-3">
      <b-row no-gutters class="d-flex justify-content-start align-items-stretch bg-white h-100">
        <b-col align-v="center" sm="12" md="6" lg="6">
          <b-card class="border-0" style="height:800px;">
            <div class="card-text">
              <div style="">
                <b-embed type="iframe"  :src="url" aspect="1by1" style="-webkit-overflow-scrolling: touch;overflow-y: scroll;" height="800px"></b-embed>
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <loading :show="show" :label="label" :overlay="overlay"></loading>
      <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </b-container>
  </div>
</template>
<script>
import Simplert from 'vue2-simplert'
import loading from 'vue-full-loading'
import Vue from 'vue'
export default {
  name: 'stamoplynsninger',
  components: {
    loading,
    Simplert,
    Vue
  },
  data () {
    return {
      selected: '',
      salesPerson: '',
      imgPicked: '',
      consent: '0',
      show: false,
      label: 'Loading...',
      overlay: 1,
      modalShowMail: false,
      isLoadingMail: false,
      items: [],
      images: [],
      textReason: '',
      url: '',
      startend: '',
      finishend: '',
      imageSelect: '',
      message: '',
      haaCredit: false,
      opsige: false,
      Canexpire: true,
      showimentor: true,
      opsigedone: false,
      showDismissibleAlert: false,
      customer: {
        name: '',
        email: ''
      },
      customers: []
    }
  },
  methods: {
    Reload () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = {operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            this.items = res
            this.images = res.resultImages
            if (this.images.length !== 0) {
              this.imgPicked = this.images[0].FileLocation
            }
            this.url = 'https://prisberegning.dk/kunde/UpdatePartnerListNew.php?iframe=1&id=' + res.encodeupdate
          },
          response => {
            alert('error')
          }
        )
    },
    service_jule_action () {
      this.show = true
      this.salesPerson = localStorage.getItem('id_token_portal')
      this.haaId = localStorage.getItem('haaid')
      var data = {operation: 'service_jule_action', salesPerson: this.salesPerson, levid: this.haaId, customers: JSON.stringify(this.customers), imgPicked: this.imgPicked, bcc: this.consent}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            var res = response.body
            this.show = false
            if (res.login === false) {
              this.$router.push('/login')
            }
            if (res.success) {
              this.modalShowDato = false
              let obj = {
                title: 'Gennemført!',
                message: 'Dit elektroniske julekort er nu sendt til dine kunder.',
                type: 'success'
              }
              this.customers = []
              this.customers.push(Vue.util.extend({}, this.customer))
              this.$refs.simplert.openSimplert(obj)
            } else {
              alert(res.message)
            }
          },
          response => {
            alert('error')
          }
        )
    },
    addCustomer () {
      this.customers.push(Vue.util.extend({}, this.customer))
    },
    delCustomer (index) {
      Vue.delete(this.customers, index)
    }
  },
  created () {
    this.customers.push(Vue.util.extend({}, this.customer))
    this.Reload()
  }
}
</script>
<style>

</style>


// WEBPACK FOOTER //
// stamoplysninger.vue?c7d20cea